import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
    selector: 'page-gallery',
    templateUrl: 'gallery.html',
})
export class GalleryPage {

    private photos: any;

    constructor(public platform: Platform, public db: AngularFirestore) {
        this.photos = [];
    }

    ionViewDidLoad() {
        this.db.doc("other/gallery").valueChanges().subscribe(gallery => {
            this.photos = gallery['gallery'];
        })
    }
}



// WEBPACK FOOTER //
// ./src/pages/gallery/gallery.ts